import React from 'react';
import Dots from '../Dots';
import Arrows from '../Arrows';
import { LeftGradientBackground, RightGradientBackground } from './styled';
import { type HandleDealCardCtaCallBack } from '../../types';

type Props = {
  selectedItem: number;
  galleryContainerNode: Element | null;
  itemsLength: number;
  isOverlay: boolean;
  handleDealCardCtaCallBack: HandleDealCardCtaCallBack;
  showGradient?: boolean;
  showArrows?: boolean;
  showDots?: boolean;
  isAlternativeDates?: boolean;
  fullWidthOnMobile?: boolean;
};

const Carousel = ({
  selectedItem,
  galleryContainerNode,
  itemsLength,
  isOverlay,
  handleDealCardCtaCallBack,
  showGradient,
  showArrows = true,
  showDots = true,
  isAlternativeDates,
  fullWidthOnMobile,
}: Props) => {
  const showLeftBg = showArrows && selectedItem !== 0 && showGradient;
  const showRightBg = showArrows && selectedItem !== itemsLength - 1 && showGradient;
  return (
    <>
      {showArrows && (
        <Arrows
          selectedItem={selectedItem}
          galleryContainerNode={galleryContainerNode}
          itemsLength={itemsLength}
          isOverlay={isOverlay}
          handleDealCardCtaCallBack={handleDealCardCtaCallBack}
          useTransparency={!showGradient}
          isAlternativeDates={isAlternativeDates}
        />
      )}
      {showLeftBg && <LeftGradientBackground />}
      {showRightBg && <RightGradientBackground />}
      {showDots && (
        <Dots
          itemsLength={itemsLength}
          selectedItem={selectedItem}
          galleryContainerNode={galleryContainerNode}
          isOverlay={isOverlay}
          handleDealCardCtaCallBack={handleDealCardCtaCallBack}
          fullWidthOnMobile={fullWidthOnMobile}
        />
      )}
    </>
  );
};

export default Carousel;
